import get from 'lodash/get';
import normalize from './filter-options-normalizer';
import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

export const consts = createReqConsts('dashboard', 'locations-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'get',
  slug: [
    'locations',
    {
      type: 'payload.query',
      queryParameter: 'assigned_to_user',
      selector: 'assignedToUser',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.SUCCEED: {
      const data = normalize({ locations: payload });
      return {
        ...state,
        sending: false,
        succeed: true,
        ...data,
        locationsList: payload,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/locations-req.js